module.exports = __webpack_public_path__ + "static/media/one-bed-smart-bg-1.4d9c4cfa.jpg";